<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faInfoCircle)
</script>
<template>
  <FontAwesomeIcon icon="fa-info-circle" />
</template>
